import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83558546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bus-arrival-select-container" }
const _hoisted_2 = {
  class: "custom-select",
  id: "arrival-time"
}
const _hoisted_3 = {
  key: 0,
  class: "custom-option-wrapper"
}
const _hoisted_4 = ["value", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        onClick: $setup.handleClickTimeSelect,
        "aria-label": "버스도착시간 기준 선택"
      }, [
        _createElementVNode("span", null, _toDisplayString($props.selectedOption.name), 1 /* TEXT */),
        ($setup.isLoggedIn)
          ? (_openBlock(), _createBlock($setup["InlineSvg"], {
              key: 0,
              class: "down-arrow-icon",
              src: require('@/assets/icons/reverse-triangle.svg'),
              alt: "아래 화살표",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["src"]))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.shouldShowOptionWrapper)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass([{
            selected: option.type === $props.selectedOption.type,
            dimmed:
              option.type === $setup.ArrivalTimeOptionCode.TMAP &&
              (!$props.isAllocExisted || $props.isInsideShuttle),
          }, "custom-option"]),
                key: index,
                value: option.type,
                onClick: ($event: any) => ($setup.handleChangeOption(option))
              }, _toDisplayString(option.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}